import { Component } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { MessageService } from "primeng/api";
import { MessageModule } from "primeng/message";
import { ToastModule } from "primeng/toast";

@Component({
    selector: 'app-admin',
    standalone: true,
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    imports: [RouterModule, ToastModule, MessageModule],
})
export class AdminComponent {
    constructor(
        private messageService: MessageService
    ){}

}
